import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';

import getSources from '~/components/StreamPlayer/playerSources';
import { HLS, OVENPLAYER } from '~/components/StreamPlayer/playerTechs';

const Player = () => {
  const { streamId } = useParams();
  const location = useLocation();
  const [scriptsLoaded, setScriptsLoaded] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!scriptsLoaded) return;

    OvenPlayer.create('player', {
      sources: getSources(
        OVENPLAYER,
        params.get('vjsTech') || HLS,
        { id: streamId },
        null,
        params.get('playbackKey')
      ),
      autoFallback: true,
      webrtcConfig: {
        timeoutMaxRetry: 1,
        connectionTimeout: 2500,
      },
    });
  }, [scriptsLoaded]);

  useEffect(() => {
    const scriptElements = [];

    const loadScripts = async () => {
      // Load OvenPlayer
      const ovenScript = document.createElement('script');
      ovenScript.src = '/ovenplayer/ovenplayer.js';
      ovenScript.async = true;
      scriptElements.push(ovenScript);

      // Load HLS.js
      const hlsScript = document.createElement('script');
      hlsScript.src = 'https://unpkg.com/hls.js@1.0.2/dist/hls.min.js';
      hlsScript.async = true;
      scriptElements.push(hlsScript);

      // Append scripts to document
      document.body.appendChild(ovenScript);
      document.body.appendChild(hlsScript);

      // Wait for scripts to load
      await Promise.all([
        new Promise((resolve) => {
          ovenScript.onload = resolve;
        }),
        new Promise((resolve) => {
          hlsScript.onload = resolve;
        }),
      ]);

      setScriptsLoaded(true);
    };

    loadScripts();

    // Cleanup function
    return () => {
      scriptElements.forEach((script) => document.body.removeChild(script));
    };
  }, []);

  return <div id="player" />;
};

export default Player;
